export const OPEN_MODEL = 'OPEN_MODEL';
export const CLOSE_MODEL = 'CLOSE_MODEL';
